module.exports = __webpack_public_path__ + "img/map_all_exclusive-party-areas-2.21eecb09.jpg";